/**
* IntWeb.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { getCookie } from '@ms/1ds-core-js';
var IntWeb = /** @class */ (function () {
    function IntWeb(propertiesConfig) {
        this.serviceName = propertiesConfig.serviceName ? propertiesConfig.serviceName : '';
    }
    Object.defineProperty(IntWeb.prototype, "msfpc", {
        /**
         * Anonymous visitor Id in hosting domain.
         */
        get: function () {
            return getCookie('MSFPC');
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(IntWeb.prototype, "anid", {
        /**
         * ANON - MSA Anonymous ID.
         */
        get: function () {
            return getCookie('ANON').slice(0, 34);
        },
        enumerable: true,
        configurable: true
    });
    ;
    return IntWeb;
}());
export { IntWeb };
//# sourceMappingURL=IntWeb.js.map